// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1HFZo"};